export const routesEnGb = [
  {
    path: 'en',
    children: [
      {
        path: '',
        loadComponent: () => import('../page/landings/home/home.component').then((m) => m.HomeComponent),
        data: { page: 'home' }
      },
      {
        path: 'solutions',
        children: [
          {
            path: 'smart-office',
            loadComponent: () => import('../page/landings/smart/smart.component').then((m) => m.SmartComponent),
            data: { page: 'smart' }
          },
          {
            path: 'meeting-room-booking-software',
            loadComponent: () => import('../page/landings/meeting-room/meeting-room.component').then((m) => m.MeetingRoomComponent),
            data: { page: 'meeting' }
          },
          {
            path: 'hybrid-work',
            loadComponent: () => import('../page/landings/flex/flex.component').then((m) => m.FlexComponent),
            data: { page: 'flex' }
          },
          {
            path: 'remote-work',
            loadComponent: () => import('../page/landings/remote/remote.component').then((m) => m.RemoteComponent),
            data: { page: 'remote' }
          },
          {
            path: 'parking-management-software',
            loadComponent: () => import('../page/landings/parking/parking.component').then((m) => m.ParkingComponent),
            data: { page: 'parking' }
          }
        ]
      },
      {
        path: 'integrations',
        children: [
          {
            path: 'desk-booking-microsoft-teams',
            loadComponent: () => import('../page/landings/waldo/waldo.component').then((m) => m.WaldoComponent),
            data: { page: 'waldo' }
          },
          {
            path: 'google-workspace-desk-booking-add-on',
            loadComponent: () => import('../page/landings/google/google.component').then((m) => m.GoogleComponent),
            data: { page: 'google' }
          }
        ]
      },
      {
        path: 'marketplace',
        loadComponent: () =>
          import('../page/landings/marketplace/marketplace.component').then((m) => m.MarketplaceComponent),
        data: { page: 'marketplace' },
        children: [
          {
            path: ':id',
            loadComponent: () => import('../page/landings/partner/partner.component').then((m) => m.PartnerComponent),
            data: { page: 'marketplace' }
          }
        ]
      },
      {
        path: 'popup',
        children: [
          {
            path: 'offers',
            loadComponent: () => import('../page/popups/offers/offers.component').then((m) => m.OffersComponent),
            data: { page: 'popups.offers', hideHeaderAndFooter: true }
          },
          {
            path: 'offers-contact',
            loadComponent: () =>
              import('../page/popups/offers-contact/offers-contact.component').then((m) => m.OffersContactComponent),
            data: { page: 'popups.offers-contact', hideHeaderAndFooter: true }
          },
          {
            path: 'map-contact',
            loadComponent: () =>
              import('../page/popups/map-contact/map-contact.component').then((m) => m.MapContactComponent),
            data: { page: 'popups.map-contact', hideHeaderAndFooter: true }
          }
        ]
      },
      {
        path: 'glossary-hybrid-work',
        loadComponent: () => import('../page/landings/glossary/glossary.component').then((m) => m.GlossaryComponent),
        data: { page: 'glossary' },
        children: [
          {
            path: ':id',
            loadComponent: () =>
              import('../page/landings/definition/definition.component').then((m) => m.DefinitionComponent),
            data: { page: 'glossary' }
          }
        ]
      },
      {
        path: 'our-offer',
        loadComponent: () => import('../page/landings/offer/offer.component').then((m) => m.OfferComponent),
        data: { page: 'offer' }
      },
      {
        path: 'contact',
        loadComponent: () => import('../page/landings/contact/contact.component').then((m) => m.ContactComponent),
        data: { page: 'contact' }
      },
      {
        path: 'contact-premium',
        loadComponent: () =>
          import('../page/landings/contact-premium/contact-premium.component').then((m) => m.ContactPremiumComponent),
        data: { page: 'contact_premium', hideHeaderAndFooter: true }
      },
      {
        path: 'demo',
        loadComponent: () => import('../page/landings/contact/contact.component').then((m) => m.ContactComponent),
        data: { page: 'contact' }
      },
      {
        path: 'submit-an-idea',
        loadComponent: () =>
          import('../page/landings/contact-idea/contact-idea.component').then((m) => m.ContactIdeaComponent),
        data: { page: 'idea' }
      },
      {
        path: 'join-the-team',
        loadComponent: () =>
          import('../page/landings/contact-join-team/contact-join-team.component').then(
            (m) => m.ContactJoinTeamComponent
          ),
        data: { page: 'join_team' }
      },
      {
        path: 'message-sent',
        loadComponent: () =>
          import('../page/landings/message-envoye/message-envoye.component').then((m) => m.MessageEnvoyeComponent),
        data: { page: 'message_sent' }
      },
      {
        path: 'privacy-policy',
        loadComponent: () =>
          import('../page/landings/privacy-policy/privacy-policy.component').then((m) => m.PrivacyPolicyComponent),
        data: { page: 'privacy_policy' }
      },
      {
        path: 'terms-of-use',
        loadComponent: () =>
          import('../page/landings/terms-of-use/terms-of-use.component').then((m) => m.TermsOfUseComponent),
        data: { page: 'terms_of_use' }
      }
    ]
  }
];
